module.exports = "td .geo-button {\n    margin-bottom: 0;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/abastecimentos/bombas/bomba-auditoria-detail/bomba-auditoria-detail.component.css
 ** module id = 567
 ** module chunks = 0
 **/